import { isPanelOwned, type Frame } from '../store/types';

/**
 * Whether a frame should render as a node on the canvas. Chat frames are
 * excluded — conversations live in the Editor Panel and surface on canvas as
 * lightweight chips (see ChatChips). Note frames hide when annotations are off.
 */
export function isCanvasRenderable(f: Frame, annotationsVisible: boolean): boolean {
  if (isPanelOwned(f)) return false;
  if (f.kind === 'chat') return false;
  if (f.kind === 'note' && !annotationsVisible) return false;
  return true;
}
